import prefetch from '~lib/prefetch';
import { events } from '~services';
import { compose, mapProps, withProps } from 'incompose';
import template from './EventsList';

export default compose(
  prefetch(() => events.fetchCurrentUserEvents(), 'events'),
  withProps({
    title: 'Сейчас',
    isTimeShown: true,
  }),
  mapProps(({ events = {}, ...rest }) => ({
    events: events.list,
    ...rest,
  })),
)(template);
